import { useState, useEffect } from "react";
import axios from "axios";

export type ConnectionStatus = "nowifi" | "noping" | "ok";

let intervalId: NodeJS.Timeout | null = null;
let isPingingGlobal = true;

const useOnlineStatus = (): ConnectionStatus => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [isPinging, setIsPinging] = useState<boolean>(false);

  const updateOnlineStatus = () => {
    setIsOnline(navigator.onLine);
  };

  const pingAddress = async () => {
    try {
      await axios.get("https://dns.google.com/resolve", {
        params: {
          name: "google.com",
          type: "A",
        },
        timeout: 2000,
      });

      isPingingGlobal = true;
      setIsPinging(true);
    } catch (error) {
      isPingingGlobal = false;
      setIsPinging(false);
    }
  };

  useEffect(() => {
    window.addEventListener("online", updateOnlineStatus);
    window.addEventListener("offline", updateOnlineStatus);

    if (!intervalId) {
      pingAddress();
      intervalId = setInterval(pingAddress, 5000);
    }

    return () => {
      window.removeEventListener("online", updateOnlineStatus);
      window.removeEventListener("offline", updateOnlineStatus);
    };
  }, []);

  const getStatus = () => {
    if (!isOnline) {
      return "nowifi";
    }
    if (!isPingingGlobal) {
      return "noping";
    }
    return "ok";
  };

  return getStatus();
};

export default useOnlineStatus;